import React from "react";
import Button from "elements/Button";
import IconGH from "assets/images/icons/IconGH.png";
import IconFB from "assets/images/icons/ic_fb.png";
import IconIG from "assets/images/icons/ic_ig.png";
import IconTktok from "assets/images/icons/ic_tiktok.png";

export default function Footer() {
  return (
    <footer className="bg-light pt-5">
      <div className="container">
        <div className="row text-start text-md-left justify-content-center gy-4" style={{ fontSize: "0.9rem" }}>
          
          {/* Logo dan Sosial Media */}
          <div className="col-12 col-md-4 text-center text-md-start">
            <img src={IconGH} alt="Icon GH" width={130} className="mb-2" />
            <p className="brand-tagline mb-3">
              Tempat Sempurna untuk Setiap Momen.
            </p>
            <div>
              <a
                href="https://www.facebook.com/GreenHillKemuning"
                target="_blank"
                rel="noreferrer"
                className="me-3"
              >
                <img src={IconFB} alt="fb-GH" width={25} />
              </a>
              <a
                href="https://www.instagram.com/villa_greenhillresort/?hl=id"
                target="_blank"
                rel="noreferrer"
                className="me-3"
              >
                <img src={IconIG} alt="ig-GH" width={25} />
              </a>
              <a
                href="https://www.tiktok.com/@villa.greenhillkemuning"
                target="_blank"
                rel="noreferrer"
              >
                <img src={IconTktok} alt="tiktok-GH" width={25} />
              </a>
            </div>
          </div>

          {/* Company */}
          <div className="col-6 col-md-2">
            <h6 className="mt-2 mb-3 fw-semibold" style={{ color: "#333333" }}>
              Company
            </h6>
            <ul className="list-unstyled">
              <li className="list-group-item">
                <Button type="link" href="/about">
                  Tentang Kami
                </Button>
              </li>
              <li className="list-group-item">
                <Button type="link" href="/products">
                  Produk Kami
                </Button>
              </li>
              <li className="list-group-item">
                <Button type="link" href="/contact">
                  Hubungi Kami
                </Button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div className="col-6 col-md-2">
            <h6 className="mt-2 mb-3 fw-semibold" style={{ color: "#333333" }}>
              Products
            </h6>
            <ul className="list-unstyled">
              <li className="list-group-item">
                <Button type="link" href="/products">
                  Villa
                </Button>
              </li>
              <li className="list-group-item">
                <Button type="link" href="/products">
                  Venue Event
                </Button>
              </li>
              <li className="list-group-item">
                <Button type="link" href="/products">
                  Hotels
                </Button>
              </li>
            </ul>
          </div>

          {/* Connect Us */}
          <div className="col-12 col-md-3">
            <h6 className="mt-2 mb-3 fw-semibold" style={{ color: "#333333" }}>
              Connect Us
            </h6>
            <ul className="list-unstyled">
              <li className="list-group-item">
                <Button
                  isExternal
                  type="link"
                  href="mailto:adminGH@kemuninggroup.co.id"
                >
                  adminGH@kemuninggroup.co.id
                </Button>
              </li>
              <li className="list-group-item">
                <Button type="link" href="tel:+6281317311631">
                  0813-1731-1631
                </Button>
              </li>
              <li>
                <span>Green Hill Resort, Puncak Cipanas - Bogor</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer bawah */}
      <p
        className="text-center mt-5 mb-0 p-3"
        style={{
          backgroundColor: "#4D4D4D",
          fontSize: "0.85rem",
          color: "#fff",
        }}
      >
        Copyright © 2025 greenhillkemuning.id • All Rights Reserved
      </p>
    </footer>
  );
}
